/**
 * Where the OTHER application is.
 *
 * This console never navigates into the ERP itself — a platform administrator
 * has no account in anybody's organization, and following one of these links
 * would land them on a sign-in page. What it does do, constantly, is hand the
 * address to somebody who does: with a new owner's credentials, and whenever
 * support is asked "where do we log in?".
 *
 * So the ERP's URL scheme is knowledge this app holds about a system it does
 * not own, which is exactly the kind of thing that should be written down in
 * ONE place. If ERP-FRONTEND changes how it addresses an organization, this
 * file is the change.
 *
 * The base comes from VITE_TENANT_APP_URL, because the two applications are
 * deployed to different hosts and this one cannot infer the other's.
 */

const base = () => (import.meta.env.VITE_TENANT_APP_URL ?? 'http://localhost:5173').replace(/\/+$/, '');

/** The ERP itself — where organization users sign in. */
export const tenantAppUrl = () => base();

/**
 * One organization's home in the ERP.
 *
 * Every screen in the tenant application lives under `/org/<handle>/`, so this
 * is not merely "where the app is" — it is where THIS organization is, and
 * opening it puts the user inside the right one without them having to choose.
 */
export const organizationUrl = (slug) => `${base()}/org/${encodeURIComponent(slug)}`;
